import React from 'react'
import { Button } from '@/components/ui/Button'
import { Phone, Clock, Wrench } from 'lucide-react'

const CallManagement: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-[70vh] px-6">
      <div className="text-center space-y-6 max-w-xl">
        <div className="mx-auto w-20 h-20 bg-primary-50 border border-primary-100 flex items-center justify-center">
          <Phone className="w-9 h-9 text-primary-600" />
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-primary-600 mb-1">Callcenter</p>
          <h1 className="text-2xl font-serif font-medium text-slate-900">Arama Yönetimi</h1>
        </div>
        <p className="text-slate-600">
          VoIP ve çağrı yönetimi özellikleri yakında eklenecek. Şu anda geliştirme aşamasında.
        </p>
        <div className="bg-white border border-slate-200 border-t-2 border-t-gold-500 p-5 text-left">
          <h2 className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-2">Planlanan özellikler</h2>
          <ul className="list-disc pl-5 space-y-1 text-sm text-slate-600">
            <li>Gerçek zamanlı arama başlatma/karşılama</li>
            <li>Çağrı notları ve çağrı geçmişi</li>
            <li>Arama kayıtları ve performans istatistikleri</li>
            <li>Takım bazlı yetkilendirme ve kuyruk yönetimi</li>
          </ul>
        </div>
        <div className="flex items-center justify-center gap-3 text-slate-500">
          <Clock className="w-4 h-4" />
          <span>Yakında kullanıma sunulacak</span>
        </div>
        <Button variant="outline" disabled>
          <Wrench className="w-4 h-4 mr-2" />
          Çalışmalar sürüyor
        </Button>
      </div>
    </div>
  )
}

export default CallManagement
